import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ClipboardDialogComponent } from './clipboard-dialog.component';

@NgModule({
  declarations: [ClipboardDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule],
  exports: [ClipboardDialogComponent],
  entryComponents: [ClipboardDialogComponent],
})
export class ClipboardDialogModule {}
